import React from 'react';

import { TableBody } from '@mui/material';

import { SchoolLevelHelper } from '../../../../helpers/school-level.helper';
import { StaffTravelHelper } from '../../../../helpers/staff-travel.helper';
import { IStaffTravel, IStaffTravelGroup } from '../../../../types/staff-travel.type';
import { StringUtils } from '../../../../utils/string.utils';
import StaffTravelListGroup from '../StaffTravelListGroup';
import StaffTravelListItem from '../StaffTravelListItem';

interface IProps {
  travel: IStaffTravel[];
}

const StaffTravelListBody = React.memo(({ travel }: IProps) => {
  const renderStaff = React.useMemo(() => {
    if (!travel?.length) {
      return null;
    }

    const grouped = SchoolLevelHelper.groupByCode<IStaffTravelGroup>(travel);

    return Object.entries(grouped)
      .map(([group, groupedTravel]) => (
        <React.Fragment key={StringUtils.random(36)}>
          {groupedTravel.map((travelItem) => (
            <StaffTravelListItem key={StaffTravelHelper.makeKey(travelItem)} travel={travelItem} />
          ))}

          <StaffTravelListGroup groupName={group} travel={groupedTravel} />
        </React.Fragment>
      ))
      .flat();
  }, [travel]);

  return <TableBody>{renderStaff}</TableBody>;
});

export default StaffTravelListBody;
